export const mobileNavWrapper = {
    width: 300,
    paddingTop: "10vh"
}

export const mobileNavListItemTextStyle = {

}